// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/ProductShort/style.css
// module id = 1846
// module chunks = 0